import { Component, ElementRef, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { Globals } from 'src/app/globals';
import { BreakpointService } from 'src/app/services/breakpoint.service';
import { Data2Service } from 'src/app/services/data2/data2.service';

@Component({
  selector: 'app-navigation-footer',
  templateUrl: './navigation-footer.component.html',
  styleUrls: ['./navigation-footer.component.scss'],
  imports: [ReactiveFormsModule, FormsModule, CommonModule, RouterModule]
})
export class NavigationFooterComponent {
  /** Native <dialog> replaces the Bootstrap modal (no Bootstrap JS or CSS needed). */
  @ViewChild('subscribeDialog') subscribeDialog?: ElementRef<HTMLDialogElement>;

  subscribeForm;
  emailSubscribeSubmitting = false;
  emailSubscribed = false;

  private lastFocused: HTMLElement | null = null;
  private closeTimer: ReturnType<typeof setTimeout> | undefined;

  constructor(
    public globals: Globals,
    public bps: BreakpointService,
    private fb: FormBuilder,
    private data2Service: Data2Service,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.subscribeForm = fb.group({
      email: ['', Validators.email]
    });
  }

  newsletterSubscribeClick(): void {
    if (!isPlatformBrowser(this.platformId)) { return; }
    const dialog = this.subscribeDialog?.nativeElement;
    if (!dialog || dialog.open) { return; }
    this.lastFocused = document.activeElement as HTMLElement | null;
    dialog.showModal();   // traps focus, Escape closes, page behind is inert
  }

  closeSubscribe(): void {
    const dialog = this.subscribeDialog?.nativeElement;
    if (dialog?.open) { dialog.close(); }
  }

  /** Clicking the dimmed backdrop (outside the panel) closes the dialog. */
  onDialogClick(event: MouseEvent): void {
    if (event.target === this.subscribeDialog?.nativeElement) {
      this.closeSubscribe();
    }
  }

  /** Runs for every close path (button, Escape, backdrop, auto-close). */
  onDialogClosed(): void {
    clearTimeout(this.closeTimer);
    this.lastFocused?.focus();
    this.lastFocused = null;
  }

  submitEmailSubscribe(): void {
    if (this.emailSubscribeSubmitting || this.subscribeForm.invalid) { return; }
    const email = this.subscribeForm.value.email;
    if (email == null || email === '') { return; }

    this.emailSubscribeSubmitting = true;
    this.data2Service.emailSubscribe(email).subscribe(() => {
      this.emailSubscribed = true;
      this.emailSubscribeSubmitting = false;
      this.closeTimer = setTimeout(() => this.closeSubscribe(), 3000);
      if (isPlatformBrowser(this.platformId)) {
        sessionStorage.setItem('email', email ?? '');
      }
    });
  }
}
